import React from 'react'
import Btn from './Button.module.css'


const Button=(props)=>{
    return(
         <button onClick={props.clickhandler} className={Btn[props.ClassBtn]}>{props.Value}</button>
        
    )
}
export default Button;